import { render, staticRenderFns } from "./sample-orders.vue?vue&type=template&id=522c272b&scoped=true"
import script from "./sample-orders.vue?vue&type=script&lang=js"
export * from "./sample-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522c272b",
  null
  
)

export default component.exports